export function HeroSectionBackground() {
  return (
    <svg
      viewBox="0 0 1920 1126"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="absolute inset-0 h-full opacity-50"
    >
      <rect height="1126" fill="#EFEFEF" />
      <g clipPath="url(#clip0_236_12590)">
        <rect transform="translate(0 -109)" fill="#F7F9FC" />
        <rect
          x="1920"
          y="1126"
          height="1126"
          transform="rotate(180 1920 1126)"
          fill="none"
          className="w-full"
        />
        <g opacity="0.6" filter="url(#filter0_f_236_12590)">
          <rect y="-109" width="811" height="843" rx="270.5" fill="none" />
        </g>
        <g filter="url(#filter1_f_236_12590)">
          <rect
            x="1071"
            y="112"
            width="693"
            height="401"
            rx="200.5"
            fill="none"
          />
        </g>
        <g opacity="0.06" clipPath="url(#clip1_236_12590)">
          <mask
            id="mask0_236_12590"
            maskUnits="userSpaceOnUse"
            x="-1186"
            y="0"
            width="1846"
            height="982"
          >
            <path
              d="M-1185.59 981.001L659.253 981L659.253 0.000549316L-1185.59 0.000710598L-1185.59 981.001Z"
              fill="white"
            />
          </mask>
          <g mask="url(#mask0_236_12590)">
            <path
              d="M177.536 777.979C181.439 711.84 109.807 668.483 52.8024 702.962C1.77093 738.38 -113.744 820.208 -163.176 854.781C-128.23 854.828 -101.844 857.6 -71.4134 836.18C-59.7961 828.006 65.0782 740.259 72.7447 734.904C86.1022 726.496 105.386 726.308 118.791 735.092C127.821 740.541 134.5 748.996 137.839 759.002C147.293 786.998 125.422 817.484 95.6971 817.061L23.1712 817.061L-30.353 854.781L95.6971 854.781C100.118 854.781 104.445 854.405 108.678 853.748C146.164 847.782 175.137 816.497 177.536 778.026"
              fill="#B8BBBD"
            />
            <path
              d="M177.536 777.979C181.439 711.84 109.807 668.483 52.8024 702.962C1.77093 738.38 -113.744 820.208 -163.176 854.781C-128.23 854.828 -101.844 857.6 -71.4134 836.18C-59.7961 828.006 65.0782 740.259 72.7447 734.904C86.1022 726.496 105.386 726.308 118.791 735.092C127.821 740.541 134.5 748.996 137.839 759.002C147.293 786.998 125.422 817.484 95.6971 817.061L32.625 817.061L-20.8992 854.781L95.6971 854.781C100.118 854.781 104.445 854.405 108.678 853.748C146.164 847.782 175.137 816.497 177.536 778.026"
              fill="#B8BBBD"
            />
            <path
              d="M-70.2379 893.816C-74.1416 959.955 -2.50943 1003.31 54.4953 968.833C105.527 933.415 221.041 851.587 270.474 817.014C235.528 816.967 209.142 814.196 178.711 835.616C167.094 843.789 42.2195 931.536 34.553 936.891C21.1955 945.3 1.91173 945.488 -11.4929 936.703C-20.5233 931.255 -27.202 922.799 -30.4944 912.794C-39.9482 884.797 -18.0776 854.312 11.6477 854.734L42.9721 854.734L96.4963 817.014L11.6007 817.014C7.1795 817.014 2.85236 817.39 -1.38066 818.048C-38.8664 824.013 -67.8391 855.298 -70.2379 893.769"
              fill="#B8BBBD"
            />
            <path
              d="M492.237 777.979C496.141 711.84 424.508 668.483 367.504 702.962C316.472 738.38 200.958 820.208 151.478 854.781C186.424 854.828 212.81 857.6 243.241 836.18C254.858 828.006 379.732 740.259 387.399 734.904C400.756 726.496 420.04 726.308 433.445 735.092C442.475 740.541 449.154 748.996 452.446 759.002C461.9 786.998 440.029 817.484 410.304 817.061L301.186 817.061L247.662 854.781L410.304 854.781C414.725 854.781 419.052 854.405 423.285 853.748C460.724 847.782 489.744 816.497 492.143 778.026"
              fill="#B8BBBD"
            />
            <path
              d="M-152.687 662.331C-156.591 728.47 -84.9586 771.826 -27.9539 737.348C23.0775 701.929 138.592 620.148 188.024 585.528C153.078 585.481 126.693 582.71 96.2619 604.13C84.6446 612.303 -40.2297 700.05 -47.8962 705.406C-61.2537 713.814 -80.5375 714.002 -93.9421 705.218C-102.973 699.769 -109.651 691.313 -112.944 681.308C-122.397 653.312 -100.527 622.826 -70.8015 623.248L-39.4771 623.248L14.0471 585.528L-70.8016 585.528C-75.2227 585.528 -79.5498 585.904 -83.7828 586.562C-121.269 592.528 -150.241 623.812 -152.64 662.284"
              fill="#CDCFD0"
            />
            <path
              d="M95.1801 546.445C99.0839 480.306 27.4517 436.949 -29.553 471.428C-80.5845 506.846 -196.099 588.627 -245.531 623.247C-210.585 623.294 -184.2 626.065 -153.769 604.645C-142.151 596.472 -17.2773 508.725 -9.61083 503.37C3.74672 494.962 23.0305 494.774 36.4351 503.558C45.4656 509.007 52.1443 517.462 55.4367 527.467C64.8904 555.464 43.0198 585.95 13.2946 585.527L-34.1623 585.527L-87.6866 623.247L13.2946 623.247C17.7158 623.247 22.0428 622.871 26.2759 622.214C63.7616 616.248 92.7343 584.963 95.1331 546.492"
              fill="#CDCFD0"
            />
            <path
              d="M-152.687 662.331C-156.591 728.47 -84.9586 771.826 -27.9539 737.348C23.0775 701.929 138.592 620.148 188.024 585.528C153.078 585.481 126.693 582.71 96.2619 604.13C84.6446 612.303 -40.2297 700.05 -47.8962 705.406C-61.2537 713.814 -80.5375 714.002 -93.9421 705.218C-102.973 699.769 -109.651 691.313 -112.944 681.308C-122.397 653.312 -100.527 622.826 -70.8015 623.248L-39.4771 623.248L14.0471 585.528L-70.8016 585.528C-75.2227 585.528 -79.5498 585.904 -83.7828 586.562C-121.269 592.528 -150.241 623.812 -152.64 662.284"
              fill="#CDCFD0"
            />
            <path
              d="M161.874 662.329C157.971 728.468 229.603 771.825 286.608 737.346C337.639 701.928 453.154 620.147 502.586 585.527C467.64 585.48 441.254 582.709 410.823 604.129C399.206 612.302 274.332 700.049 266.665 705.404C253.308 713.812 234.024 714 220.619 705.216C211.589 699.767 204.91 691.312 201.618 681.307C192.164 653.31 214.035 622.824 243.76 623.247L275.084 623.247L328.609 585.527L243.76 585.527C239.339 585.527 235.012 585.903 230.779 586.56C193.293 592.526 164.32 623.811 161.922 662.282"
              fill="#CDCFD0"
            />
            <path
              d="M409.788 546.445C413.691 480.306 342.059 436.95 285.054 471.428C234.023 506.846 118.508 588.628 69.076 623.247C104.022 623.294 130.408 626.066 160.839 604.646C172.456 596.472 297.33 508.725 304.997 503.37C318.354 494.962 337.638 494.774 351.043 503.558C360.073 509.007 366.752 517.463 370.044 527.468C379.498 555.464 357.627 585.95 327.902 585.528L280.445 585.528L226.921 623.247L327.902 623.247C332.323 623.247 336.65 622.872 340.883 622.214C378.369 616.248 407.342 584.964 409.74 546.492"
              fill="#CDCFD0"
            />
            <path
              d="M13.5776 316.133C17.4813 249.994 -54.1509 206.638 -111.156 241.116C-162.187 276.534 -277.702 358.316 -327.181 392.935C-292.235 392.982 -265.849 395.754 -235.418 374.334C-223.801 366.16 -98.9269 278.413 -91.2604 273.058C-77.9029 264.65 -58.619 264.462 -45.2145 273.246C-36.184 278.695 -29.5053 287.151 -26.2129 297.156C-16.7591 325.152 -38.6297 355.638 -68.355 355.215L-131.427 355.215L-184.951 392.935L-68.355 392.935C-63.9338 392.935 -59.6067 392.56 -55.3737 391.902C-17.8879 385.936 11.0848 354.652 13.4835 316.18"
              fill="#B8BBBD"
            />
            <path
              d="M-234.196 432.017C-238.1 498.156 -166.468 541.513 -109.463 507.034C-58.4313 471.616 57.0833 389.835 106.516 355.215C71.5696 355.168 45.1838 352.397 14.753 373.817C3.13572 381.99 -121.738 469.737 -129.405 475.092C-142.763 483.5 -162.046 483.688 -175.451 474.904C-184.481 469.455 -191.16 461 -194.452 450.995C-203.906 422.998 -182.036 392.512 -152.31 392.935L-120.986 392.935L-67.4617 355.215L-152.31 355.215C-156.732 355.215 -161.059 355.591 -165.292 356.248C-202.777 362.214 -231.75 393.499 -234.149 431.97"
              fill="#B8BBBD"
            />
            <path
              d="M328.327 316.133C332.23 249.994 260.598 206.637 203.593 241.116C152.562 276.534 37.0474 358.315 -12.3849 392.935C22.5611 392.982 48.9469 395.753 79.3777 374.333C90.995 366.16 215.869 278.413 223.536 273.058C236.893 264.65 256.177 264.462 269.582 273.246C278.612 278.695 285.291 287.15 288.583 297.155C298.037 325.152 276.166 355.638 246.441 355.215L178.289 355.215L124.765 392.935L246.441 392.935C250.862 392.935 255.189 392.559 259.422 391.901C296.908 385.936 325.881 354.651 328.28 316.18"
              fill="#B8BBBD"
            />
            <path
              d="M328.327 316.133C332.23 249.994 260.598 206.637 203.593 241.116C152.562 276.534 37.0474 358.315 -12.3849 392.935C22.5611 392.982 48.9469 395.753 79.3777 374.333C90.995 366.16 215.869 278.413 223.536 273.058C236.893 264.65 256.177 264.462 269.582 273.246C278.612 278.695 285.291 287.15 288.583 297.155C298.037 325.152 276.166 355.638 246.441 355.215L183.369 355.215L129.845 392.935L246.441 392.935C250.862 392.935 255.189 392.559 259.422 391.901C296.908 385.936 325.881 354.651 328.28 316.18"
              fill="#B8BBBD"
            />
            <path
              d="M80.5522 432.017C76.6484 498.156 148.281 541.513 205.285 507.034C256.317 471.616 371.831 389.835 421.264 355.215C386.318 355.168 359.932 352.397 329.501 373.817C317.884 381.99 193.01 469.737 185.343 475.092C171.986 483.5 152.702 483.688 139.297 474.904C130.267 469.455 123.588 461 120.296 450.995C110.842 422.998 132.712 392.512 162.438 392.935L193.809 392.935L247.333 355.215L162.438 355.215C158.017 355.215 153.689 355.591 149.456 356.248C111.971 362.214 82.9979 393.499 80.5992 431.97"
              fill="#B8BBBD"
            />
            <path
              d="M643.028 316.133C646.932 249.994 575.299 206.638 518.295 241.116C467.263 276.534 351.749 358.316 302.316 392.935C337.262 392.982 363.648 395.754 394.079 374.334C405.696 366.16 530.57 278.413 538.237 273.058C551.594 264.65 570.878 264.462 584.283 273.246C593.313 278.695 599.992 287.151 603.284 297.156C612.738 325.152 590.867 355.638 561.142 355.215L452.024 355.215L398.5 392.935L561.189 392.935C565.61 392.935 569.938 392.56 574.171 391.902C611.656 385.936 640.629 354.652 643.028 316.18"
              fill="#B8BBBD"
            />
            <path
              d="M-310.626 203.021C-314.529 269.16 -242.897 312.517 -185.892 278.038C-134.861 242.62 -19.3464 160.792 30.0859 126.219C-4.86005 126.172 -31.2459 123.4 -61.6766 144.821C-73.2939 152.994 -198.168 240.741 -205.835 246.096C-219.145 254.504 -238.476 254.692 -251.881 245.908C-260.911 240.459 -267.59 232.004 -270.929 221.998C-280.383 194.002 -258.512 163.516 -228.787 163.939L-197.463 163.939L-143.938 126.219L-228.787 126.219C-233.208 126.219 -237.535 126.595 -241.768 127.252C-279.254 133.218 -308.227 164.502 -310.626 202.974"
              fill="#CDCFD0"
            />
            <path
              d="M3.93489 203.021C0.0311094 269.16 71.6633 312.516 128.668 278.038C179.699 242.619 295.214 160.791 344.693 126.218C309.747 126.171 283.362 123.4 252.931 144.82C241.313 152.993 116.439 240.74 108.773 246.095C95.4153 254.504 76.1315 254.692 62.7269 245.908C53.6964 240.459 47.0177 232.003 43.6783 221.998C34.2245 194.002 56.0952 163.516 85.8204 163.938L117.145 163.938L170.669 126.218L85.8204 126.218C81.3992 126.218 77.0721 126.594 72.8391 127.252C35.3533 133.217 6.38061 164.502 3.9819 202.974"
              fill="#CDCFD0"
            />
            <path
              d="M251.85 87.1358C255.754 20.9968 184.122 -22.36 127.117 12.1187C76.0855 47.5369 -39.4291 129.365 -88.9084 163.938C-53.9625 163.985 -27.5766 166.756 2.85417 145.336C14.4715 137.163 139.346 49.4158 147.012 44.0608C160.37 35.6525 179.653 35.4647 193.058 44.2487C202.088 49.6977 208.767 58.153 212.107 68.1584C221.56 96.1547 199.69 126.641 169.965 126.218L122.508 126.218L68.9834 163.938L169.965 163.938C174.386 163.938 178.713 163.562 182.946 162.904C220.432 156.939 249.404 125.654 251.803 87.1827"
              fill="#CDCFD0"
            />
            <path
              d="M3.93489 203.021C0.0311094 269.16 71.6633 312.516 128.668 278.038C179.699 242.619 295.214 160.791 344.693 126.218C309.747 126.171 283.362 123.4 252.931 144.82C241.313 152.993 116.439 240.74 108.773 246.095C95.4153 254.504 76.1315 254.692 62.7269 245.908C53.6964 240.459 47.0177 232.003 43.6783 221.998C34.2245 194.002 56.0952 163.516 85.8204 163.938L117.145 163.938L170.669 126.218L85.8204 126.218C81.3992 126.218 77.0721 126.594 72.8391 127.252C35.3533 133.217 6.38061 164.502 3.9819 202.974"
              fill="#CDCFD0"
            />
            <path
              d="M318.542 203.02C314.639 269.159 386.271 312.516 443.275 278.037C494.307 242.619 609.821 160.791 659.301 126.218C624.355 126.171 597.969 123.4 567.538 144.82C555.921 152.993 431.047 240.74 423.38 246.095C410.023 254.503 390.739 254.691 377.334 245.907C368.304 240.458 361.625 232.003 358.333 221.997C348.879 194.001 370.75 163.515 400.475 163.938L431.799 163.938L485.323 126.218L400.475 126.218C396.054 126.218 391.727 126.594 387.494 127.251C350.008 133.217 321.035 164.502 318.636 202.973"
              fill="#CDCFD0"
            />
            <path
              d="M566.457 87.1368C570.361 20.9977 498.729 -22.359 441.724 12.1197C390.693 47.5379 275.178 129.366 225.699 163.939C260.645 163.986 287.031 166.757 317.462 145.337C329.079 137.164 453.953 49.4168 461.62 44.0618C474.93 35.6535 494.261 35.4656 507.665 44.2497C516.696 49.6987 523.375 58.1539 526.714 68.1593C536.168 96.1557 514.297 126.642 484.572 126.219L437.115 126.219L383.591 163.939L484.572 163.939C488.993 163.939 493.32 163.563 497.553 162.905C535.039 156.94 564.012 125.655 566.41 87.1837"
              fill="#CDCFD0"
            />
          </g>
          <rect x="-5" y="-149" width="640" height="1158" />
        </g>
      </g>
      <defs>
        <filter
          id="filter0_f_236_12590"
          x="-300"
          y="-409"
          width="1411"
          height="1443"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="150"
            result="effect1_foregroundBlur_236_12590"
          />
        </filter>
        <filter
          id="filter1_f_236_12590"
          x="771"
          y="-188"
          width="1293"
          height="1001"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feGaussianBlur
            stdDeviation="150"
            result="effect1_foregroundBlur_236_12590"
          />
        </filter>
        <linearGradient
          id="paint0_linear_236_12590"
          x1="-5.00004"
          y1="265.18"
          x2="635"
          y2="265.18"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="none" />
          <stop offset="1" stopColor="none" stopOpacity="0" />
        </linearGradient>
        <clipPath id="clip0_236_12590">
          <rect
            width="1920"
            height="6755"
            fill="white"
            transform="translate(0 -109)"
          />
        </clipPath>
        <clipPath id="clip1_236_12590">
          <rect
            width="1844.85"
            height="981"
            fill="white"
            transform="translate(659.255 981) rotate(180)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
